"use strict";
class PercentageHighlighter {
    // コンストラクタで処理を実行
    constructor() {
        // 処理する対象のクラスリスト
        this.targetClasses = [
            "c-position_s-1",
            "c-position_s-2",
            "c-position_s-3",
            "c-position_s-4",
            "c-line1-1",
            "c-line1-2",
            "c-line1-3",
            "c-line1-4",
            "c-line2-1",
            "c-line2-2",
            "c-line2-3",
            "c-line2-4",
            "c-line3-1",
            "c-line3-2",
            "c-line3-3",
            "c-line3-4",
            "c-line4-1",
            "c-line4-2",
            "c-line4-3",
            "c-line4-4",
        ];
        this.targetClasses.forEach((targetClass) => {
            this.processClass(targetClass);
        });
    }
    // 特定のクラスに対する処理を行うメソッド
    processClass(targetClass) {
        // 指定クラスの全ての要素を取得
        const elements = document.querySelectorAll(`.${targetClass}`);
        // 最大パーセント値を追跡する変数
        let maxPercentage = -1;
        // 最大パーセント値を持つ要素のリスト
        let maxElements = [];
        // 各要素をループして処理
        elements.forEach((element) => {
            if (element instanceof HTMLElement) {
                const percentValue = this.extractPercentValue(element);
                if (percentValue !== null) {
                    // 新しい最大値を見つけた場合、リストをクリアして追加
                    if (percentValue > maxPercentage) {
                        maxPercentage = percentValue;
                        maxElements = [element];
                    }
                    // 同率の場合、リストに追加
                    else if (percentValue === maxPercentage) {
                        maxElements.push(element);
                    }
                }
            }
        });
        // 最大パーセント値を持つすべての要素の親要素にクラスを付与
        maxElements.forEach((element) => {
            this.addClassToParentElement(element);
        });
    }
    // 要素からパーセント値を抽出するメソッド
    extractPercentValue(element) {
        const text = element.textContent || element.innerText;
        const percentMatch = text.match(/(\d+(?:\.\d+)?)%/);
        if (percentMatch) {
            return parseFloat(percentMatch[1]);
        }
        return null;
    }
    // 親要素にクラスを追加するメソッド
    addClassToParentElement(element) {
        // 要素が存在し、かつ最大パーセント値が0より大きい場合のみクラスを追加
        if (element && element.parentElement) {
            const percentValue = this.extractPercentValue(element);
            if (percentValue !== null && percentValue > 0) {
                element.parentElement.classList.add("highest-percentage");
            }
        }
    }
}
new PercentageHighlighter();
